module.exports = __webpack_public_path__ + "img/back1.7d4a371c.png";